<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="home-popup-modal-label">{{ modalTitle() }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-html="modalBody()"></div>

            <div v-if="data.link_value" :class="buttonContainerClass()">
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="openLink()">
                    {{ buttonText() }}
                </button>
            </div>
        </div>
        <div class="modal-footer">
            <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="doNotShowAgain()"
                :disabled="preview"
            >
                {{ $root.text('Do not show again', null, true) }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                data: {},
                preview: false,
                folders: []
            }
        },
        mounted () {
            //
        },
        watch: {
            //
        },
        methods: {
            reset: function (data, preview = false) {
                this.data = data;
                this.preview = preview;
                this.getFolders();
            },
            modalTitle: function () {
                return this.data.title || '';
            },
            modalBody: function () {
                return this.data.body_text || '';
            },
            buttonText: function () {
                return this.data.button_text || '';
            },
            buttonContainerClass: function () {
                let className = 'mt-3';
                switch (this.data.button_position) {
                    case 'center':
                        className += ' text-center';
                        break;
                    case 'left':
                        className += ' text-left';
                        break;
                    case 'right':
                        className += ' text-right';
                        break;
                }

                return className;
            },
            openLink: function () {
                if (!this.data.link_value) {
                    console.log('no link value');
                    return false;
                }
                if ((this.data.link_type == 'folder') || (this.data.link_type == 'subfolder')) {
                    if (!this.hasFolders()) {
                        console.log('no home folders');
                        return null;
                    }
                    this.$root.asset_filters = [];
                    const linkValueParts = this.data.link_value.split('::');
                    const folderId = parseInt(linkValueParts[0]);
                    let folder = null;
                    this.folders.forEach((item) => {
                        if (item.id == folderId) {
                            folder = item;
                        }
                    });
                    if (!folder) {
                        console.log('folder not found');
                        return null;
                    }
                    let liveSubfolders = [];
                    folder.subfolders.forEach((item) => {
                        if (!item.archived) {
                            liveSubfolders.push(item);
                        }
                    });
                    this.$root.addFilter('asset_filters', {
                        key: 'folder',
                        value: folderId,
                        subfolders: liveSubfolders,
                        text: '<i class="fal fa-folder font-size-16 mr-1"></i> '
                            + folder.name.replace(/"/g, '&quot;').replace(/'/g, '&apos;'),
                        filters_key: 'asset_filters'
                    });
                    if (this.data.link_type == 'subfolder') {
                        const subfolderId = parseInt(linkValueParts[2]);
                        let subfolder = null;
                        liveSubfolders.forEach((item) => {
                            if (item.id == subfolderId) {
                                subfolder = item;
                            }
                        });
                        this.$root.addFilter('asset_filters', {
                            key: 'subfolder',
                            value: subfolderId,
                            name: subfolder.name,
                            text: '<i class="fal fa-folder-tree font-size-16 mr-1"></i> '
                                + subfolder.name.replace(/"/g, '&quot;').replace(/'/g, '&apos;'),
                            filters_key: 'asset_filters'
                        });
                    }
                    this.$router.push({ name: 'assets' });
                }
                if (this.data.link_type == 'asset') {
                    this.$root.asset_filters = [];
                    this.$root.addFilter('asset_filters', {
                        key: 'resource_id',
                        value: parseInt(this.data.link_value),
                        text: '&quot;' + this.data.link_value + '&quot;',
                        filters_key: 'asset_filters'
                    });
                    this.$router.push({ name: 'assets' });

                    return null;
                }
                if (this.data.link_type == 'latest_assets') {
                    this.$root.asset_filters = [];
                    this.$root.addFilter('asset_filters', {
                        key: 'limit',
                        value: parseInt(this.data.link_value),
                        text: this.$root.text(
                            'Latest {x} uploads / edited {resources}',
                            {
                                x: this.data.link_value,
                                resources: this.$root.text(this.$root.contents.asset_title + 's', null, false,
                                    'assets_title')
                            },
                            true
                        ),
                        filters_key: 'asset_filters'
                    });
                    this.$router.push({ name: 'assets' });

                    return null;
                }
                if (this.data.link_type == 'keywords') {
                    this.$root.asset_filters = [];
                    const keywords = this.data.link_value.split(',');
                    this.$root.addFilter('asset_filters', {
                        key: 'keyword',
                        value: '[E]||' + keywords.join('||'),
                        text: '&quot;' + keywords.join('&quot;, &quot;').replace(/"/g, '&quot;')
                            .replace(/'/g, '&apos;') + '&quot;',
                        filters_key: 'asset_filters'
                    });
                    this.$router.push({ name: 'assets' });

                    return null;
                }
                if (this.data.link_type == 'url') {
                    const self = (this.data.link_value.indexOf('/') == 0);
                    window.open(this.data.link_value, self ? '_self' : '_blank').focus();

                    return null;
                }
                if (this.data.link_type == 'collection') {
                    const linkValueParts = this.data.link_value.split('::');
                    this.$router.push({ name: 'view-collection', params: { id: parseInt(linkValueParts[0]) } });

                    return null;
                }
                if (this.data.link_type == 'collections') {
                    this.$root.collection_filters = [];
                    const collectionIds = this.data.link_value.split(',');
                    collectionIds.forEach((item, index) => {
                        this.addCollectionFilter(item, (index == collectionIds.length - 1));
                    });

                    return null;
                }
            },
            addCollectionFilter: function (collectionId, redirectToCollections = false) {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/collection/' + collectionId;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.$root.addFilter('collection_filters', {
                        key: 'collection_id',
                        value: response.data.collection.id,
                        text: response.data.collection.name.replace(/"/g, '&quot;').replace(/'/g, '&apos;'),
                        filters_key: 'collection_filters'
                    });
                    if (redirectToCollections) {
                        vm.$root.addFilter('collection_filters', {
                            key: 'sort_by',
                            value: 'name_asc',
                            text: 'Order results by: Name',
                            filters_key: 'collection_filters'
                        });
                        vm.$root.addFilter('collection_filters', {
                            key: 'from_home_panel',
                            value: true,
                            text: '',
                            filters_key: 'collection_filters'
                        });
                        setTimeout(function () {
                            vm.$router.push({ name: 'collections' });
                        }, 200);
                    }
                })
                .catch(function (error) {
                    //
                });
            },
            doNotShowAgain: function () {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/homepage-popup/' + this.data.id
                    + '/mark-as-viewed';
                var vm = this;

                axios({
                    method: 'put',
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    //
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            getFolders: function () {
                /**
                 * Send request to API.
                 */
                let url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/folders/!pagination|!archived';
                if (this.$root.client.hide_empty_folders) {
                    url += '|!empty';
                }
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.folders = response.data.folders;
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            hasFolders: function () {
                if (!this.folders) {
                    return false;
                }
                if (this.folders.length == 0) {
                    return false;
                }

                return true;
            }
        }
    }
</script>
